import React from 'react';

import { useBrandContext } from 'modules/brand/context/BrandContext';
import useGetBrandVenues from 'modules/brand/hooks/useGetBrandVenues';

import InsightRoutes from '../InsightRoutes';

const FeatureBrandInsights = () => {
  const { brand } = useBrandContext();

  const { venues, isLoading } = useGetBrandVenues({ brand });
  const activeVenues = venues?.filter(venue => venue.status === 'VENUE_PUBLISHED');

  // isWoltPlus will be populated when Japan enterprise team will implement this flag.
  // after that we should also use useInsightV2WoltPlusHidden hook to calculate isWoltPlus.
  return brand && !isLoading ? (
    <InsightRoutes
      insightEntity={{
        type: 'brand',
        id: brand.id,
        isWoltPlus: false,
        venues: activeVenues,
        country: brand.country as Country,
      }}
    />
  ) : null;
};

export default FeatureBrandInsights;
